import {
  Component,
  Injectable,
  OnInit,
  TemplateRef,
  ViewChild,
  ElementRef,
  HostListener,
  AfterViewInit,
  ChangeDetectorRef,
} from '@angular/core';
import { Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { BsModalService, Utils } from 'ngx-bootstrap';
import { CalendarComponent } from 'ng-fullcalendar';
import { Options } from 'fullcalendar';

import * as _ from 'lodash';
import { IvrService } from '../../../../../common/services/Ivr.service';
import { UploadService } from '../../../../../common/services/Upload.service';
import { CommonService } from '../../../../../common/services/Common.service';
import { moment } from 'ngx-bootstrap/chronos/test/chain';
import { TimeService } from '../../../../../common/services/Time.service';
import { UtilityService } from 'app/common/services/Utility.service';
import { TimeConst } from './time.const';
import { TableAction } from '../../../../../components/table-component/table.const';
import { BaseListComponent } from '../../../../../components/base-list.component';
import { FormFieldType, ModalType } from '../../../../../components/modals/modal-form-template/modal-form.const';

declare var $: any;

@Component({
  moduleId: module.id,
  selector: 'worktime',
  templateUrl: './time.component.html',
  styleUrls: ['./time.css'],
  providers: [BsModalService, TimeService, UtilityService],
})
@Injectable()
export class TimeComponent extends BaseListComponent {
  calendarOptions: Options;
  @ViewChild(CalendarComponent) ucCalendar: CalendarComponent;

  @ViewChild('templateSchedule') templateSchedule: ElementRef;
  @ViewChild('templateEvent') templateEvent: ElementRef;

  public listSchedule: any = [];
  public modelEvent: any = {};
  public id_delete: number;
  public current_schedule_id: any;
  public current_schedule: any;
  public limit = 15;
  public isLoad = false;
  public totalSchedule = 0;
  public keyword = '';
  public listSchedule_page_devide: any = [];
  public listPeriod: any = [];

  public displayEvent: any;

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    private timeService: TimeService
  ) {
    super(changeDetector, toastr, modalService);
    this.displayColumns = TimeConst.displayColumns();
  }

  ngOnInit() {
    this.loadData();
  }

  async detailSchedule(schedule, force = false) {
    const request: any = {};
    let payload = await this.buildBasePayload(request, {});
    this.current_schedule_id = schedule.TIME_SCHEDULE_ID;
    request.TIME_SCHEDULE_ID = this.current_schedule_id;
    this.current_schedule = schedule;
    this.timeService.listPeriod(payload).subscribe(res => {
      if (!res.error && res.status == 200) {
        this.listPeriod = res.data.data;
        this.initPage(res.data.total);
        this.listPeriod.map(res => {
          res.display_time = TimeConst.displayTimeColumns(res);
          res.DAY_OF_WEEK_TRANSLATE = TimeConst.displayDayOfWeekColumns(res);
          res.DATE_FROM_VN = TimeConst.displayDayColumns(res.DATE_FROM);
          res.DATE_TO_VN = TimeConst.displayDayColumns(res.DATE_TO);
          res.display_period = TimeConst.displayPeriodColumns(res);
          return res;
        });
      }
    });
  }

  async loadData(request = {}, sort = {}) {
    let payload = await this.buildBasePayload(request, sort);
    payload['limit'] = this.limit;
    payload['keyword'] = this.keyword;
    this.timeService.listSchedule(payload).subscribe(res => {
      if (res.status == 200 && !res.error) {
        this.listSchedule = res.data.data;
        this.isLoad = false;
        this.totalSchedule = res.data.total.total;
        if (this.listSchedule.length > 0) {
          this.detailSchedule(this.listSchedule[0]);
        }
        this.listSchedule_page_devide = this.listSchedule.slice(0, this.limit);
      }
    });
  }
  async setUpModal(type, channel) {
    this.typeModal = type;
    switch (channel) {
      case 'schedule':
        this.modelContent = {
          type: ModalType.Primary,
          title: this.typeModal === 'add' ? 'Thêm mới kế hoạch' : 'Cập nhật kế hoạch',
          submit_title: this.typeModal === 'add' ? 'Thêm mới' : 'Cập nhật',
        };
        this.modelDisplay = [
          {
            key: 'TIME_SCHEDULE_NAME',
            label: 'Tên kế hoạch',
            type: FormFieldType.Text,
            value: this.model.TIME_SCHEDULE_NAME,
            required: true,
            disabled: false,
            width: 'full',
            order: 0,
          },
        ];
        break;
      case 'period':
        this.modelContent = {
          type: ModalType.Primary,
          title: this.typeModal === 'add' ? 'Thêm mới sự kiện' : 'Cập nhật sự kiện',
          submit_title: this.typeModal === 'add' ? 'Thêm mới' : 'Cập nhật',
        };
        this.modelDisplay = [
          {
            key: 'TIME_PERIOD_NAME',
            label: 'Tên sự kiện',
            type: FormFieldType.Text,
            value: this.model.TIME_PERIOD_NAME,
            required: true,
            disabled: false,
            width: 'full',
            order: 0,
          },
          {
            key: 'HFROM',
            label: 'Thời gian bắt đầu',
            type: FormFieldType.Timepicker,
            value: this.model.HFROM,
            required: true,
            disabled: false,
            width: '1/2',
            order: 1,
          },
          {
            key: 'HTO',
            label: 'Thời gian kết thúc',
            type: FormFieldType.Timepicker,
            value: this.model.HTO,
            required: true,
            disabled: false,
            width: '1/2',
            order: 2,
          },
          {
            key: 'TIME_TYPE',
            label: 'Theo các ngày trong tuần',
            type: FormFieldType.Switch,
            value: this.model.TIME_TYPE,
            required: false,
            disabled: false,
            width: 'full',
            order: 3,
            options: {
              checkInline: true,
            },
          },
        ];
        if (!this.model.TIME_TYPE) {
          this.model.DAY_OF_WEEK = null;
          this.model.DATE_FROM = this.model.DATE_FROM
            ? moment(this.model.DATE_FROM).format('YYYY-MM-DD')
            : moment(new Date()).format('YYYY-MM-DD');
          this.model.DATE_TO = this.model.DATE_TO
            ? moment(this.model.DATE_TO).format('YYYY-MM-DD')
            : moment(new Date()).add('7', 'days').format('YYYY-MM-DD');
          this.modelDisplay = [
            ...this.modelDisplay,
            {
              key: 'DATE_FROM',
              label: 'Từ ngày',
              type: FormFieldType.Datepicker,
              value: this.model.DATE_FROM,
              required: true,
              disabled: false,
              width: '1/2',
              order: 4,
              options: {
                dateOptions: {
                  dateInputFormat: 'YYYY-MM-DD',
                  containerClass: 'theme-blue',
                },
              },
            },
            {
              key: 'DATE_TO',
              label: 'Đến ngày',
              type: FormFieldType.Datepicker,
              value: this.model.DATE_TO,
              required: true,
              disabled: false,
              width: '1/2',
              order: 5,
              options: {
                dateOptions: {
                  dateInputFormat: 'YYYY-MM-DD',
                  containerClass: 'theme-blue',
                },
              },
            },
          ];
        } else {
          this.model.DATE_FROM = null;
          this.model.DATE_TO = null;
          this.modelDisplay = [
            ...this.modelDisplay,
            {
              key: 'DAY_OF_WEEK',
              label: 'Thiết lập các ngày trong tuần ',
              type: FormFieldType.DayOfWeekPicker,
              value: this.model.DAY_OF_WEEK,
              required: true,
              disabled: false,
              width: 'full',
              order: 6,
              options: {
                format: 'YYYY/MM/DD',
              },
            },
          ];
        }
        break;
    }
  }
  async saveEvent(payload, period_id = null) {
    if (period_id) {
      this.timeService.updatePeriod(period_id, payload).subscribe(
        res => {
          if (res.status == 200 && !res.error) {
            this.throwSuccess('Cập nhật thành công!');
            this.detailSchedule(this.current_schedule, true);
            this.closeModal();
          } else {
            this.message = {
              class: 'alert dark alert-danger',
              content: res.message,
            };
          }
        },
        error => {
          this.message = {
            class: 'alert dark alert-danger',
            content: error.message,
          };
        }
      );
    } else {
      this.timeService.createPeriod(payload).subscribe(
        res => {
          if (res.status == 200 && !res.error) {
            this.throwSuccess('Thêm mới thành công!');
            this.detailSchedule(this.current_schedule, true);
            this.closeModal();
          } else {
            this.message = {
              class: 'alert dark alert-danger',
              content: res.message,
            };
          }
        },
        error => {
          this.message = {
            class: 'alert dark alert-danger',
            content: error.message,
          };
        }
      );
    }
  }

  async saveSchedule(payload, schedule_id: any = null) {
    if (schedule_id) {
      this.timeService.updateSchedule(schedule_id, payload).subscribe(
        res => {
          if (res.status == 200 && !res.error) {
            this.throwSuccess('Cập nhật thành công!');
            this.loadData();
            this.closeModal();
          } else {
            this.message = {
              class: 'alert dark alert-danger',
              content: res.message,
            };
          }
        },
        error => {
          this.message = {
            class: 'alert dark alert-danger',
            content: error.message,
          };
        }
      );
    } else {
      this.timeService.createSchedule(payload).subscribe(
        res => {
          if (res.status == 200 && !res.error) {
            this.throwSuccess('Thêm mới thành công!');
            this.loadData();
            this.closeModal();
          } else {
            this.message = {
              class: 'alert dark alert-danger',
              content: res.message,
            };
          }
        },
        error => {
          this.message = {
            class: 'alert dark alert-danger',
            content: error.message,
          };
        }
      );
    }
  }

  async openConfirmDeleteEvent(id) {
    this.delete_id = id;
    const y = confirm('Bạn có muốn xóa sự kiện này không?');
    if (y) {
      await this.submitDeleteEvent(id);
    }
  }

  async submitDeleteEvent(event_id) {
    this.timeService.deletePeriod(event_id).subscribe(
      res => {
        if (res.status == 200 && !res.error) {
          this.throwSuccess('Xóa thành công!');
          this.detailSchedule(this.current_schedule, true);
        } else {
          this.throwError(res.message);
        }
      },
      error => {
        this.throwError(error.message);
      }
    );
  }

  async openConfirmDelete(id) {
    this.delete_id = id;
    // this.modalRef2 = this.modalService.show(template);
    const y = confirm('Bạn có muốn xóa kế hoạch này không?');
    if (y) {
      await this.submitDelete(id);
    }
  }
  async submitDelete(id) {
    this.timeService.deleteSchedule(id).subscribe(
      res => {
        if (res.status == 200 && !res.error) {
          this.throwSuccess('Xóa thành công!');
          this.loadData();
        } else {
          this.throwError(res.message);
        }
      },
      error => {
        this.throwError(error.message);
      }
    );
  }
  @HostListener('scroll', ['$event'])
  onLazyload(event: any) {
    const totalScroll1 = event.target.offsetHeight + Math.round(event.target.scrollTop) - 1;
    const totalScroll2 = event.target.offsetHeight + Math.round(event.target.scrollTop);
    const totalScroll3 = event.target.offsetHeight + Math.round(event.target.scrollTop) + 1;
    const scrollHeight = event.target.scrollHeight;
    if (
      (totalScroll1 === scrollHeight || totalScroll2 === scrollHeight || totalScroll3 === scrollHeight) &&
      !this.isLoad &&
      (this.totalSchedule >= this.limit || (this.listSchedule.length == 0 && this.totalSchedule >= this.limit))
    ) {
      setTimeout(() => {
        this.limit += 15;
        this.isLoad = true;
        this.loadData();
      }, 500);
    }
  }

  async setPage(page: number) {
    if (page <= this.totalPage) {
      if (page < 1) {
        page = 1;
      }
      if (page != this.currentPage) {
        this.currentPage = page;
        await this.detailSchedule(this.current_schedule);
      }
    } else {
      page = this.totalPage;
      $('#inputPage').val(page);
      this.toastr.warning('Số trang tối đa hiện tại là ' + page, '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
      if (page <= this.totalPage) {
        if (page < 1) {
          page = 1;
        }
        if (page != this.currentPage) {
          this.currentPage = page;
          await this.detailSchedule(this.current_schedule);
        }
      }
    }
  }
  async handleAction(type: any, item?: any, channel?: any) {
    this.model = {};
    let config = {
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-md',
    };
    switch (type) {
      case TableAction.add:
        if (channel === 'schedule') {
          await this.setUpModal('add', 'schedule');
          this.openModal(
            this.templateSchedule,
            config,
            {},
            {
              modelContent: this.modelContent,
              modelDisplay: this.modelDisplay,
            }
          );
        } else if (channel === 'period') {
          this.model.HFROM = '00:00';
          this.model.HTO = '23:59';
          await this.setUpModal('add', 'period');
          this.openModal(
            this.templateEvent,
            config,
            {},
            {
              modelContent: this.modelContent,
              modelDisplay: this.modelDisplay,
            }
          );
        }
        break;
      case TableAction.edit:
        this.model = item;
        if (channel === 'schedule') {
          await this.setUpModal('edit', 'schedule');
          this.openModal(this.templateSchedule, config, item, {
            modelContent: this.modelContent,
            modelDisplay: this.modelDisplay,
          });
        } else if (channel === 'period') {
          if (item.DAY_OF_WEEK && _.isString(item.DAY_OF_WEEK)) {
            item.DAY_OF_WEEK = item.DAY_OF_WEEK.split(',');
          }
          await this.setUpModal('edit', 'period');
          this.openModal(this.templateEvent, config, item, {
            modelContent: this.modelContent,
            modelDisplay: this.modelDisplay,
          });
        }
        break;
      case TableAction.delete:
        if (channel === 'schedule') {
          await this.openConfirmDelete(item.TIME_SCHEDULE_ID);
        } else if (channel === 'period') {
          await this.openConfirmDeleteEvent(item.id);
        }
        break;
    }
  }
  async handleSubmit(item?: any, channel?: any) {
    this.model = _.merge({}, this.model, item);
    switch (channel) {
      case 'schedule':
        const payload = {
          TIME_SCHEDULE_NAME: this.model.TIME_SCHEDULE_NAME.trim(),
          SCHEDULE_TYPE: this.model.SCHEDULE_TYPE ? this.model.SCHEDULE_TYPE : 0,
        };
        const id = this.typeModal === 'edit' ? parseInt(this.model.TIME_SCHEDULE_ID) : null;
        await this.saveSchedule(payload, id);
        break;
      case 'period':
        const eventPayload = {
          TIME_PERIOD_NAME: this.model.TIME_PERIOD_NAME.trim(),
          HFROM: this.model.HFROM.trim(),
          HTO: this.model.HTO.trim(),
          TIME_SCHEDULE_ID: this.current_schedule_id,
          TIME_TYPE: !!this.model.TIME_TYPE,
          DAY_OF_WEEK: this.model.DAY_OF_WEEK
            ? _.isArray(this.model.DAY_OF_WEEK)
              ? this.model.DAY_OF_WEEK.join(',')
              : this.model.DAY_OF_WEEK
            : null,
          DATE_FROM: this.model.DATE_FROM,
          DATE_TO: this.model.DATE_TO,
        };
        const eventId = this.typeModal === 'edit' ? parseInt(this.model.id) : null;
        await this.saveEvent(eventPayload, eventId);
        break;
    }
  }
  async onChangeValueModel(key, item) {
    this.model = _.merge({}, this.model, item);
    if (item.DAY_OF_WEEK) {
      this.model.DAY_OF_WEEK = Array.isArray(item.DAY_OF_WEEK) ? item.DAY_OF_WEEK : [item.DAY_OF_WEEK];
    } else {
      this.model.DAY_OF_WEEK = [];
    }
    this.message = null;
    switch (key) {
      case 'HFROM':
      case 'HTO':
        if (
          this.model.HFROM &&
          this.model.HTO &&
          moment(this.model.HFROM, 'HH:mm').isAfter(moment(this.model.HTO, 'HH:mm'))
        ) {
          this.message = {
            class: 'alert dark alert-danger',
            content: 'Thời gian kết thúc không được sớm hơn thời gian bắt đầu!',
          };
        }
        break;
      case 'DATE_FROM':
      case 'DATE_TO':
        if (this.model[key]) this.model[key] = moment(this.model[key]).format('YYYY-MM-DD 00:00:00');
        if (
          this.model.DATE_FROM &&
          this.model.DATE_TO &&
          moment(this.model.DATE_FROM).isAfter(moment(this.model.DATE_TO))
        ) {
          this.message = {
            class: 'alert dark alert-danger',
            content: 'Ngày kết thúc không được sớm hơn ngày bắt đầu!',
          };
        }
        break;
    }
    await this.setUpModal(this.typeModal, 'period');
  }
  async changePageLimit(pageSize) {
    this.page_size = pageSize;
    this.currentPage = 1;
    await this.detailSchedule(this.current_schedule);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/time/time.component.ts